<template>
    <span>
        <b-button
            class="align-baseline"
            title="Download"
            variant="default"
            :href="backup.download_url"
        >
            <font-awesome-icon :icon="['fas', 'download']"></font-awesome-icon>
        </b-button>
        <b-button
            class="align-baseline"
            title="Restore"
            variant="default"
            :disabled="!backup.permissions.restore || !!backupProgress"
            v-b-modal="restoreModalID"
        >
            <font-awesome-icon :icon="['fas', 'hard-drive']"></font-awesome-icon>
        </b-button>
        <b-button
            class="align-baseline"
            title="Delete"
            variant="default"
            :disabled="!backup.permissions.delete || !!backupProgress"
            v-b-modal="deleteModalID"
        >
            <font-awesome-icon :icon="['fas', 'trash']"></font-awesome-icon>
        </b-button>
        <modal
            :id="deleteModalID"
            title="Delete Backup"
            @shown="onModalShown"
            @ok="deleteBackup"
        >Are you sure you want to delete backup #{{ backupID }}?</modal>
        <modal
            :id="restoreModalID"
            title="Restore Backup"
            @shown="onModalShown"
            @ok="restoreBackup"
        >
            Are you sure you want to restore backup #{{ backupID }}?
            Please use with extreme caution. This may cause irreversible data loss.
        </modal>
    </span>
</template>

<script>
    import API from '../../../api';
    import Modal from '../../generic/modal/modal.vue';

    export default {
        components: {
            Modal,
        },
        computed: {
            backupProgress() {
                return this.params.backupProgressGetter();
            }
        },
        data() {
            return {
                backup: {},
                backupID: 0,
                deleteModalID: '',
                restoreModalID: '',
            };
        },
        created() {
            this.backup = this.params.data;
            this.backupID = this.backup.id;
            this.deleteModalID = `modal-delete-backup-${this.backupID}`;
            this.restoreModalID = `modal-restore-backup-${this.backupID}`;
        },
        methods: {
            onModalShown() {
                this.params.api.clearFocusedCell();
            },
            deleteBackup() {
                this.params.delete && this.params.delete(this.params);
            },
            restoreBackup() {
                this.params.restore && this.params.restore(this.params);
            }
        },
    }
</script>
